import { makeStyles } from '@material-ui/core/styles';

export const useLoadingPageStyles = makeStyles(theme => ({
  loading: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));
